import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import VaultPanel from '../components/VaultPanel';
import Dashboard from '../components/Dashboard';
import { HowItWorks, SecurityStrip, Ticker, Footer } from '../components/Sections';

export default function Landing() {
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <VaultPanel />
        <Dashboard />
        <HowItWorks />
        <SecurityStrip />
      </main>
      <Footer />
    </div>
  );
}
